import React from 'react';
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { Home, History, Profile, Privacy, Terms } from '../screens';

const router = createBrowserRouter([
	{
		path: "/",
		element: <Home />
	},
	{
		path: "/results",
		element: <History />
	},
	{
		path: "/profile",
		element: <Profile />
	},
	{
		path: "/privacy",
		element: <Privacy />
	},
	{
		path: "/terms",
		element: <Terms />
	}
]);

export default () => (<RouterProvider router={router} />);